


import InlineLoading from 'vux/src/components/inline-loading/index.vue'

import BScroll from 'better-scroll'
export default {
components: { InlineLoading },
props: {
params: { // 额外参数
type: Object,
default: () => {
return {}
}
},
fixedHeight: { // 固定高度
type: String,
default: () => {
return null
}
},
tipColor: { // 提示元素颜色
type: String,
default: '#fff'
},
refresh: { // 是否下拉刷新
type: Boolean,
default: false
},
load: { // 是否上拉加载更多
type: Boolean,
default: true
},
otherH: { // 具体数值
type: Number,
default: 0
},
eleArray: { // 需要获取高度元素类名或id的数组
type: Array,
default: () => {
return []
}
},
onlyScroll: { // 是否只是滚动效果
type: Boolean,
default: false
}
},
data() {
return {
loadOptions: {
click: true,
scrollX: false,
scrollY: true, // 因为scrollY默认为true，其实可以省略
pullDownRefresh: {
threshold: 50, // 当下拉到超过顶部 50px 时，触发 pullingDown 事件
stop: 40 
},
pullUpLoad: {
threshold: -50,// 在上拉到超过底部 20px 时，触发 pullingUp 事件
stop: 40,
moreTxt: 'Load more',
noMoreTxt: 'There is no more data'
}
},
loading: false,
topLoading: false,
bottomLoading: false,
loadType: null,
scroll: null
}
},
created() {

},
mounted() {
this.$nextTick(() => {
let timer = setTimeout(() => {
this.initScroll()
this.handleScroll()
clearTimeout(timer)
},100)

window.addEventListener('resize', this.handleScroll)
})
},
methods: {
_scroll() {
window.addEventListener('scroll', () => {
if ((document.documentElement.scrollTop || document.body.scrollTop) - document.querySelector('.game-nav').offsetTop > -5) {
console.log('----------------------------')
console.log(document.documentElement.scrollTop || document.body.scrollTop)
console.log(document.querySelector('.game-nav').offsetTop)
}
})
},
handleScroll () {
let billBox = document.querySelector('.Load-more-warp')
if (!this.fixedHeight) {
const body = document.querySelector('body')
let height = this.getCss(body, 'height')
let clientHeight = document.documentElement.clientHeight
let offsetTop = billBox.offsetTop
let ArrayTotalH = 0
this.eleArray.forEach((item) => {
if(document.querySelector(`${item}`)) ArrayTotalH = ArrayTotalH + document.querySelector(`${item}`).offsetHeight

})
if(!clientHeight){
height = ArrayTotalH > 0 ? (height - ArrayTotalH - this.otherH) : (height - offsetTop - this.otherH)
}else {
height = ArrayTotalH > 0 ? (clientHeight - ArrayTotalH - this.otherH) : (clientHeight - offsetTop - this.otherH)
}
billBox.style.height = height + 'px'
} else {
billBox.style.height = this.fixedHeight
}
},
initScroll() {
this.loadOptions.pullUpLoad.moreTxt = this.$t('others').loadingTxt
this.loadOptions.pullUpLoad.noMoreTxt = this.$t('others').noData1
if (!this.refresh) this.loadOptions.pullDownRefresh = false
if (!this.load) this.loadOptions.pullUpLoad = false
this.scroll = new BScroll(this.$refs.LoadMore, this.loadOptions)
this.scroll.on('pullingDown', () => {
if (this.loading || this.onlyScroll) return 
this.loading = true
this.topLoading = true
this.loadType = 'refresh'
this.$emit(this.loadType, { params: this.params, finish: this.finish, destroy: this._destroy })
})
this.scroll.on('pullingUp', () => {
if (this.loading || this.onlyScroll) return 
this.loading = true
this.bottomLoading = true
this.loadType = 'loadmore'
this.$emit(this.loadType, { params: this.params, finish: this.finish, destroy: this._destroy })
})
},
finish() {
let timer = setTimeout(() => {
if (this.loadType === 'refresh') {
this.topLoading = false
this.scroll.finishPullDown()
this.scroll.refresh()
}
if (this.loadType === 'loadmore') {
this.bottomLoading = false
this.scroll.finishPullUp()
this.scroll.refresh()
}
this.loadType = null
this.loading = false
clearTimeout(timer)
},500)
},
getCss(curEle, attr) {
let val = null,reg = null
if("getComputedStyle" in window){
val = window.getComputedStyle(curEle,null)[attr]
}else{
val = curEle.currentStyle[attr]
}
reg = /^(-?\d+(\.\d+)?)(px|pt|rem|em)?$/i
return reg.test(val)?parseFloat(val):val
},
_destroy() {
if (this.scroll) this.scroll.destroy()
},
scrollToTop() { // 返回顶部
console.log('返回顶部')
if (this.scroll) this.scroll.scrollTo(0, 0, 500)
},
scrollToBottom() { // 返回底部
if (this.scroll) this.scroll.scrollTo(0, this.scroll.maxScrollY,500)
}
},
destroyed() {
this._destroy()
window.removeEventListener('resize', this.handleScroll)
}
}



// WEBPACK FOOTER //
// ./src/common/components/load-more/index.vue